module.exports = __webpack_public_path__ + "img/image4.df833b5b.png";